module.exports = __webpack_public_path__ + "static/KC3-5f84d7e6ec38b6737827afde54561dfa.png";